import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Space } from "antd";
import { MenuOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useMaterialUIController, setLayout, setMiniSidenav } from "context";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div 
      className="min-h-screen bg-gray-50"
      style={{
        marginRight: !isMobile ? (miniSidenav ? 80 : 280) : 0,
        transition: "margin-right 0.2s ease-in-out",
        padding: "24px",
      }}
    >
      <Space 
        direction="vertical" 
        size="middle" 
        className="w-full mb-4"
        style={{ marginBottom: 16 }}
      >
        {pathname !== "/" && (
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            onClick={() => navigate(-1)}
          >
            بازگشت
          </Button>
        )}
      </Space>

      {children}
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
